// Render a 12×12 sprite (chars '.', '1', '2', '3') to a data URL for use as a tile
// background, ported from the design prototypes. Real player sprite_data is exactly
// this format. The palette is per-world (prison greens vs ABC neon).

import type { SpritePalette } from './world';

// A neutral standing figure for players whose sprite_data we don't have.
const FALLBACK = [
  '............', '...111111...', '..13333331..', '..13333331..',
  '..13133131..', '..13333331..', '..13322331..', '..13333331..',
  '...133331...', '....1111....', '..11333311..', '.1313131313.',
];

const cache: Record<string, string> = {};

export function spriteUrl(
  rows: string[] | null | undefined,
  key: string,
  me: boolean,
  palette: SpritePalette,
): string {
  const cacheKey = palette.id + ':' + key + (me ? '!' : '');
  if (cache[cacheKey]) return cache[cacheKey];
  const grid = rows && rows.length === 12 ? rows : FALLBACK;
  const cv = document.createElement('canvas');
  cv.width = 12;
  cv.height = 12;
  const x = cv.getContext('2d');
  if (!x) return '';
  if (!me) {
    x.fillStyle = palette.disc;
    x.fillRect(0, 0, 12, 12);
  }
  const pal = me ? palette.palMe : palette.pal;
  grid.forEach((row, y) =>
    [...row.slice(0, 12)].forEach((ch, xx) => {
      if (pal[ch]) {
        x.fillStyle = pal[ch];
        x.fillRect(xx, y, 1, 1);
      }
    }),
  );
  cache[cacheKey] = cv.toDataURL();
  return cache[cacheKey];
}
